import React, { Component } from "react";
import {
  Wrapper,
  Button,
  Card,
  Gradient,
  Title,
  Bold,
  Row,
  Spin
} from "app/NativeComponents/common";

import { dismissMobileKeyboard } from "app/NativeActions";

class SendButton extends Component {
  render() {
    const {
      started_sending,
      colors,
      multisend_numbers_loading,
      sending_over,
      multisend_number,
      multisend_numbers,
      current_message_text,
      selected_from_number
    } = this.props;

    if (!started_sending) {
      if (multisend_numbers_loading) {
        return (
          <Card style={{ margin: 10, borderRadius: 40, orderflow: "hidden" }}>
            <Gradient
              style={{ borderRadius: 40 }}
              color1={colors.gray_color}
              color2={colors.gray_color}
            >
              <Wrapper style={{ padding: 20 }}>
                <Row style={{ justifyContent: "center", alignItems: "center" }}>
                  <Spin size="small" />
                  <Title
                    style={{
                      marginLeft: 10,
                      textAlign: "center"
                    }}
                  >
                    Loading...
                  </Title>
                </Row>
              </Wrapper>
            </Gradient>
          </Card>
        );
      }

      if (multisend_numbers.length == 0) {
        return (
          <Button onPress={() => this.props.handleBack()}>
            <Card style={{ margin: 10, borderRadius: 40, orderflow: "hidden" }}>
              <Gradient
                style={{ borderRadius: 40 }}
                color1={colors.card_color}
                color2={colors.card_color}
              >
                <Wrapper style={{ padding: 20 }}>
                  <Title
                    style={{
                      color: colors.text_color,
                      textAlign: "center"
                    }}
                  >
                    No Numbers Selected. Dismiss
                  </Title>
                </Wrapper>
              </Gradient>
            </Card>
          </Button>
        );
      }

      return (
        <Button onPress={() => this.props.startSending()}>
          <Card style={{ margin: 10, borderRadius: 40, orderflow: "hidden" }}>
            <Gradient
              style={{ borderRadius: 40 }}
              color1={colors.gradient_button_color_1}
              color2={colors.gradient_button_color_2}
            >
              <Wrapper style={{ padding: 20 }}>
                <Title
                  style={{
                    color: colors.white_text_color,
                    textAlign: "center"
                  }}
                >
                  Start Sending
                </Title>
              </Wrapper>
            </Gradient>
          </Card>
        </Button>
      );
    }

    if (!sending_over && multisend_number) {
      if (multisend_numbers_loading) {
        return (
          <Card style={{ margin: 10, borderRadius: 40, orderflow: "hidden" }}>
            <Gradient
              style={{ borderRadius: 40 }}
              color1={colors.gray_color}
              color2={colors.gray_color}
            >
              <Wrapper style={{ padding: 20 }}>
                <Row style={{ justifyContent: "center", alignItems: "center" }}>
                  <Spin size="small" />
                  <Title
                    style={{
                      marginLeft: 10,
                      textAlign: "center"
                    }}
                  >
                    Loading More Numbers...
                  </Title>
                </Row>
              </Wrapper>
            </Gradient>
          </Card>
        );
      }

      if (!current_message_text) {
        return (
          <Card style={{ margin: 10, borderRadius: 40, orderflow: "hidden" }}>
            <Gradient
              style={{ borderRadius: 40 }}
              color1={colors.gray_color}
              color2={colors.gray_color}
            >
              <Wrapper style={{ padding: 20 }}>
                <Row style={{ justifyContent: "center", alignItems: "center" }}>
                  <Title
                    style={{
                      marginLeft: 10,
                      textAlign: "center"
                    }}
                  >
                    Enter Text For Message
                  </Title>
                </Row>
              </Wrapper>
            </Gradient>
          </Card>
        );
      }

      if (
        (multisend_number.lead_phone_number &&
          (multisend_number.lead_phone_number.bad_phone == 1 ||
            multisend_number.lead_phone_number.blocked == 1 ||
            multisend_number.lead_phone_number.do_not_call == 1 ||
            multisend_number.lead_phone_number.landline == 1)) ||
        multisend_number.awaiting_response_lock_out ||
        multisend_number.received_response ||
        multisend_number.timezone_lock_out
      ) {
        return (
          <Wrapper style={{ backgroundColor: this.props.colors.card_color }}>
            <Button
              onPress={() => {
                this.props.skipMultiSendNumber({
                  lead_phone_id: multisend_number.lead_phone_number
                    ? multisend_number.lead_phone_number.owner_phone_number_id
                    : null,
                  lead_phone_number: multisend_number.lead_phone_number
                    ? multisend_number.lead_phone_number.phone_number
                    : null
                });
              }}
            >
              <Card
                style={{ margin: 10, borderRadius: 40, orderflow: "hidden" }}
              >
                <Gradient
                  style={{ borderRadius: 40 }}
                  color1={colors.gradient_button_color_1}
                  color2={colors.gradient_button_color_2}
                >
                  <Wrapper style={{ padding: 20 }}>
                    <Title
                      style={{
                        textAlign: "center",
                        color: colors.white_text_color
                      }}
                    >
                      Skip Message
                    </Title>
                  </Wrapper>
                </Gradient>
              </Card>
            </Button>
          </Wrapper>
        );
      }

      return (
        <Wrapper style={{ backgroundColor: this.props.colors.card_color }}>
          <Button
            onPress={() => {
              dismissMobileKeyboard();
              this.props.sendMultiSendMessage({
                token: this.props.token,
                message_text: current_message_text,
                media: null,
                lead_id: multisend_number.lead_id,
                conversation_id: null,
                to_phone_number: multisend_number.lead_phone_number
                  ? multisend_number.lead_phone_number.phone_number
                  : null,
                to_phone_number_id: multisend_number.lead_phone_number
                  ? multisend_number.lead_phone_number.owner_phone_number_id
                  : null,
                from_phone_number: selected_from_number
                  ? selected_from_number.id
                  : null
              });
            }}
          >
            <Card style={{ margin: 10, borderRadius: 40, orderflow: "hidden" }}>
              <Gradient
                style={{ borderRadius: 40 }}
                color1={colors.gradient_button_color_1}
                color2={colors.gradient_button_color_2}
              >
                <Wrapper style={{ padding: 20 }}>
                  <Title
                    style={{
                      color: colors.white_text_color,
                      textAlign: "center"
                    }}
                  >
                    Send Message
                  </Title>
                </Wrapper>
              </Gradient>
            </Card>
          </Button>
        </Wrapper>
      );
    }

    return <Wrapper />;
  }
}

export default SendButton;
